/**
 * Mock horoscope feed — mirrors the finalized Figma design.
 * Lets us build the UI before the backend endpoint exists.
 *
 * Turn it on by setting REACT_APP_USE_MOCK=true in a .env.local file (see
 * config.ts); getHoroscopeFeed() then returns this instead of hitting the API.
 *
 * Deeplinks are placeholders — the real ones come from the backend.
 */
import { HoroscopeFeedResponse } from './types'

export const horoscopeFeedMock: HoroscopeFeedResponse = {
  items: [
    {
      id: 'banner',
      type: 'BANNER_IMAGE',
      data: {
        imageUrl:
          'https://cdn-sc-g.sharechat.com/33d5318_1c8/tools/1bd1cf42_1780988220967_sc.webp',
        title: "Today's Prediction",
        subtitle: 'Based on your birth chart',
      },
    },
    {
      id: 'today',
      type: 'TODAYS_PREDICTION',
      data: {
        date: 'Tuesday, 1 Sep 2026',
        zodiac: { label: 'Sagittarius (धनु)', 'iconUrl': 'https://cdn-sc-g.sharechat.com/33d5318_1c8/tools/cdaa96f_1780891258158_sc.webp' },
        headline: 'A door is quietly opening.',
        prediction:
          "Saturn is in a slow transit through your 10th house right now — this is the grind period. Work feels heavier than it should. You're building something real but the recognition hasn't caught up yet. That changes in the next 6 to 8 weeks. You're building something real but the recognition hasn't caught up yet. That changes in the next 6 to 8 weeks.",
        lucky: {
          number: { label: 'Lucky Number', value: '9', valueText: 'Nine' },
          color: { label: 'Lucky Color', value: 'Purple', swatch: '#A020F0' },
          time: { label: 'Lucky Time', value: '7:15 AM - 10 AM' },
        },
      },
    },
    {
      id: 'astrologer',
      type: 'ASTROLOGER_CARD',
      data: {
        header: 'Find out more... ask',
        astrologer: {
          id: 'astro_123',
          name: 'Riya Sharma',
          avatarUrl: 'https://cdn-im.sharechat.com/33d5318_1c8/33ddfa55_1772544598675_sc.webp',
          socialProof: {
            imageUrl: 'https://cdn-sc-g.sharechat.com/33d5318_1c8/tools/155ba6c3_1780913073388_sc.webp',
            html: '<font color="#FFFFFF">2,000+</font> spoke today',
          },
          badge: { label: 'BEST', iconUrl: 'https://cdn-sc-g.sharechat.com/33d5318_1c8/tools/287bb5e6_1780913414699_sc.webp' }, // BE provides the star icon URL
          actions: [
            {
              mediaType: 'chat',
              label: 'Chat',
              iconUrl: 'https://cdn-sc-g.sharechat.com/33d5318_1c8/24bf8498_1777534542568_sc.svg',
              deeplink: 'https://askk.co.in/chat/astro_123',
            },
            {
              mediaType: 'audio',
              label: 'Call',
              iconUrl: 'https://cdn-sc-g.sharechat.com/33d5318_1c8/226303e4_1777449861924_sc.svg',
              deeplink: 'https://askk.co.in/call/astro_123',
            },
          ],
        },
      },
    },
  ],
}
